module.exports = __webpack_public_path__ + "static/media/anage-select-banner-footer.1f6b63f8.webp";